import { Stack } from "@similarweb/ui-components/foundations";

import type { CompanyAnalysisCompetititorItem } from "app/pages/sales-intelligence/modules/company-analysis/types/competitors";

import CompetitorsTableRow from "../CompetitorsTableRow/CompetitorsTableRow";

const COMPETITORS_COUNT = 5;

const CompetitorsCardContent = ({ competitors }: { competitors: CompanyAnalysisCompetititorItem[] | undefined }) => {
    return (
        <Stack>
            {competitors?.slice(0, COMPETITORS_COUNT).map((item, index) => (
                <CompetitorsTableRow
                    key={item.domain}
                    item={item}
                    withoutTopBorder={index === 0}
                />
            ))}
        </Stack>
    );
};

export default CompetitorsCardContent;
